function disableProductCTA(state) {
  const submitCTAs = document.querySelectorAll('.js-product-form-submit');

  submitCTAs.forEach(cta => {
    cta.disabled = !!state
  });
}
class ProductPersonalisation extends HTMLElement {
  constructor() {
    super();

    const personalisationLogo = document.querySelector('#personalisation-logo');
    const teamSelect = this.querySelector('.js-personalisation-select');

    if (personalisationLogo) {
      personalisationLogo.value.length > 0 ? disableProductCTA(false) : disableProductCTA(true);
      personalisationLogo.addEventListener('change', () => {
        personalisationLogo.value.length > 0 ? disableProductCTA(false) : disableProductCTA(true);
      });
    }

    if (teamSelect) {
      teamSelect.addEventListener('change', (e) => {
        const newImage = e.target.options[e.target.selectedIndex].dataset.image;
        const name = e.target.options[e.target.selectedIndex].value;
        this.updateLogo(newImage, name);
      });
    }
  }

  updateLogo(newImage, name) {
    const logo = this.querySelector('.js-personalisation-logo');
    if (logo && newImage) {
      logo.src = newImage;
    }

    if (name) {
      const matchingImage = document.querySelector('.c-carousel__img img[alt="' + name + '"]');

      if (matchingImage) {
        const i = matchingImage.parentElement.parentElement.dataset.index;

        document.dispatchEvent(new CustomEvent('goToSlide', {
          detail: { index: i }
        }));
      }

      logo.classList.remove('hidden');
    }
  }
}
customElements.define('product-personalisation', ProductPersonalisation);
